import { useQuery } from '@tanstack/react-query';
import { Grade, Period, Scheme, Salary } from '../api-client';
import { fetchSalaryData } from '../api';

const placeholderData: Salary[] = Array(10).fill({});

export const useSalaryData = (
    scheme: Scheme | null,
    period: Period | null,
    grade: Grade | null
) => {
  return useQuery({
    queryKey: ['salaryData', scheme?.value, period?.value, grade?.value],
    queryFn: () => fetchSalaryData(scheme!.value, period!.value, grade!.value),
    enabled: !!(scheme && period && grade),
    placeholderData:
      (previousData: Salary[] | undefined) => previousData || placeholderData,
  });
};
